var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43161 6.11343C5.25587 6.28917 5.25587 6.57409 5.43161 6.74983C5.60735 6.92556 5.89227 6.92556 6.06801 6.74983L7.99981 4.81802L9.93161 6.74983C10.1074 6.92556 10.3923 6.92556 10.568 6.74983C10.7437 6.57409 10.7437 6.28917 10.568 6.11343L8.31801 3.86343C8.23361 3.77904 8.11915 3.73163 7.99981 3.73163C7.88046 3.73163 7.766 3.77904 7.68161 3.86343L5.43161 6.11343Z",
    fill: "#777E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.568 9.61343C10.7437 9.78917 10.7437 10.0741 10.568 10.2498L8.31801 12.4998C8.14227 12.6755 7.85735 12.6755 7.68161 12.4998L5.43161 10.2498C5.25587 10.0741 5.25587 9.78917 5.43161 9.61343C5.60735 9.4377 5.89227 9.4377 6.06801 9.61343L7.99981 11.5452L9.93161 9.61343C10.1074 9.4377 10.3923 9.4377 10.568 9.61343Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.0e46b43a3ca5cf9b57f77613ab9e445f.svg";
export { ForwardRef as ReactComponent };